import * as React from "react";
import * as _ from "lodash";

/**
 * Hook that alerts clicks outside of the passed ref
 */
const useOutSideItemClick = (ref: React.RefObject<any> | Array<React.RefObject<any>>, cb: () => void, deps?: React.DependencyList) => {
  React.useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: any) {
      if (_.isArray(ref)) {
        let isInRef = false;

        for (const refInstance of ref) {
          if (refInstance.current && refInstance.current.contains(event.target)) {
            isInRef = true;
          }
        }

        if (!isInRef) {
          cb();
        }
      } else {
        if (ref.current && !ref.current.contains(event.target)) {
          cb();
        }
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ ref, ...(deps || []) ]);
};

export default useOutSideItemClick;
